import * as tslib_1 from "tslib";
import { OnDestroy, OnInit } from '@angular/core';
import * as moment from 'moment';
import { BsModalRef } from 'ngx-bootstrap';
import { Subject } from 'rxjs';
import { FichaService } from './../../../../ficha-veiculo/ficha-veiculo.service';
import { NacionalidadesService } from './../../../../services/nacionalidade/nacionalidades.service';
export class DadosComplementaresComponent {
    constructor(modal, fichaService, nacionalidadesService) {
        this.modal = modal;
        this.fichaService = fichaService;
        this.nacionalidadesService = nacionalidadesService;
        this.event = new Subject();
        this.alive = true;
        this.isNomePaiClienteTexto = false;
        this.listaNaturalCidadeCliente = [];
        this.isLoadingNaturalCidadeCliente = false;
        this.listaNacionalidadeCliente = [];
        this.isLoadingNacionalidadeCliente = false;
    }
    ngOnInit() {
        if (this.cliente.tipoDocumentoDataEmissao) {
            this.cliente.tipoDocumentoDataEmissao = moment.unix(this.cliente.tipoDocumentoDataEmissao / 1000).format('DDMMYYYY');
        }
        this.loadNacionalidadeCliente();
    }
    ngOnDestroy() {
        this.alive = false;
    }
    salvar() {
        this.cliente.tipoDocumentoDataEmissao = moment(this.cliente.tipoDocumentoDataEmissao, 'DDMMYYYY').unix() * 1000;
        this.event.next(this.cliente);
    }
    onClickNomePaiCliente() {
        this.isNomePaiClienteTexto = !this.isNomePaiClienteTexto;
        this.cliente.nomePai = this.isNomePaiClienteTexto ? 'NAO DECLARADO' : '';
    }
    loadNacionalidadeCliente() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.listaNacionalidadeCliente = [];
            this.isLoadingNacionalidadeCliente = true;
            try {
                this.listaNacionalidadeCliente = yield this.nacionalidadesService.nacionalidades().toPromise();
                if (this.cliente.naturalDeUf) {
                    yield this.loadNaturalCidadeCliente();
                }
            }
            finally {
                this.isLoadingNacionalidadeCliente = false;
            }
        });
    }
    onChangeNacionalidade(data) {
        if (data !== '1') {
            this.cliente.naturalDeUf = '';
            this.cliente.naturalDe = '';
        }
    }
    loadNaturalCidadeCliente() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.listaNaturalCidadeCliente = [];
            this.isLoadingNaturalCidadeCliente = true;
            try {
                const res = yield this.fichaService
                    .getCidadePorUf(this.cliente.naturalDeUf)
                    .toPromise();
                this.listaNaturalCidadeCliente = res.cidades;
            }
            finally {
                this.isLoadingNaturalCidadeCliente = false;
            }
        });
    }
    onChangeNaturalUfCliente() {
        this.cliente.naturalDe = '';
        this.loadNaturalCidadeCliente();
    }
    fechar() {
        this.modal.hide();
    }
}
